import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VinoItem } from 'src/app/_classi/VinoItem';
import { DialogPromoViniComponent } from 'src/app/_dialoghi/dialog-promo-vini/dialog-promo-vini.component';
import { CarrelloViniService } from 'src/app/_servizi/carrelloVini.service';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';
import { PromoService } from 'src/app/_servizi/promo.service';

@Component({
  selector: 'app-acquisto-vino',
  templateUrl: './acquisto-vino.component.html',
  styleUrls: ['./acquisto-vino.component.css']
})
export class AcquistoVinoComponent implements OnInit, OnChanges {

  @Input() vino: VinoItem;


  tvAssociata = null;
  tvSelezionata = null;

  qtaMinima = 1;
  formAnnata: FormGroup;

  promoSelezionata = null;
  codicePromo = null;

  risultato = null;

  idCookie = null;

  constructor(
    private messageService: MessageServiceService,
    private fb: FormBuilder,
    private promoService: PromoService,
    public dialog: MatDialog,
    private carrelloService: CarrelloViniService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.formAnnata = this.fb.group({
      annata: new FormControl(null)
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tvAssociata = this.vino.associata_item;

    this.vino.qta = 1;
    this.qtaMinima = this.vino.qtaMinima != 0 ? this.vino.qtaMinima : 1;
    this.vino.qta = this.qtaMinima;

    if (this.vino.annate.length == 1) {
      this.formAnnata.patchValue({
        annata: this.vino.annate[0]['idAnnata']
      });
      this.formAnnata.get('annata').updateValueAndValidity();
    }
  }


  ngOnInit(): void {
  }

  getCostoTipovisita(tipovisita): number {
    const przVisita = parseFloat(tipovisita.costoDefault);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    return przOk;
  }

  getCostoTipovisitaScontato(tipovisita, valore): number {
    const przVisita = parseFloat(tipovisita.costoMax);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    przOk = przOk - (przOk / 100 * valore);
    return przOk;
  }

  public choosePrezzoScontato(vino): number {
    if (vino.hasSconto(vino)) {
      if (vino.scontoEsclusivo) {
        return vino.prezzoScontatoWineClub;
      } else {
        return vino.prezzoScontato;
      }
    } else {
      return vino.prezzo;
    }
  }

  get totaleVini(): number {
    let costo = 0;
    costo = this.choosePrezzoScontato(this.vino) * this.vino.qta;
    return costo;
  }

  get totaleViniConPromo(): number {
    const promo = this.promoSelezionata;
    let costo = this.totaleVini;
    if (promo.promo.tipo === '0') {
      costo = costo - parseFloat(promo.promo.valore);
    } else {
      costo = costo - (costo / 100 * parseFloat(promo.promo.valore));
    }
    return costo
  }

  get totaleBaseVini(): number {
    let costo = 0;
    costo = this.vino.prezzo * this.vino.qta;
    return costo;
  }

  get totaleTv(): number {
    return this.tvSelezionata ? this.getCostoTipovisitaScontato(this.tvSelezionata, this.tvSelezionata.scontoAssociata) : 0;
  }

  get totaleGenerale(): number {
    return this.totaleVini + this.totaleTv;
  }

  get totalescontato(): number {
    let totaleScontato = 0;
    if (this.promoSelezionata && this.promoSelezionata.promo) {
      const przVino = this.totaleVini / this.vino.qta;

      const totaleVini = przVino * this.vino.qta;

      this.promoSelezionata = this.promoService.controllaPromo(
        this.promoSelezionata.promo, this.vino.qta, totaleVini, przVino, this.promoSelezionata.codice
      );

      if (this.promoSelezionata.risultato) {
        const totScontato = this.totaleGenerale - this.promoSelezionata.valore;
        totaleScontato = totScontato >= 0 ? totScontato : 0;
      } else {
        totaleScontato = this.totaleGenerale;
      }
    } else {
      totaleScontato = this.totaleGenerale;
    }
    return totaleScontato;
  }

  settaAssociata(tipovisita) {
    this.tvSelezionata = tipovisita;
  }

  resettaAssociata() {
    this.tvSelezionata = null;
  }

  vinoPiu() {
    this.vino.qta += 1;
  }

  vinoMeno() {
    if (this.vino.qta > 1 && this.vino.qta > this.qtaMinima) {
      this.vino.qta--;
    }
  }

  isDisabled() {
    return this.codicePromo == null ||
      this.codicePromo === '' ||
      (this.promoSelezionata && this.promoSelezionata.risultato)
      ? true : false;
  }

  riscattaCodice() {

    const initialState = {
      titolo: 'Riscatta il tuo codice',
      label: 'Inserisci il tuo codice regalo',
      idVino: this.vino.id,
      codiceForm: this.vino.codiceForm,
      qta: this.vino.qta,
      costoTotale: this.totaleVini,
      costoSingolo: this.totaleVini / this.vino.qta,
      isVino: true
    };

    this.riscatta(initialState)
  }

  riscatta(data) {
    this.risultato = null;
    this.promoService.riscattaCodicePromoVino(data.idVino, data.codiceForm, this.codicePromo, data.isVino)
      .subscribe(response => {
        if (response.length > 0) {
          this.controllaPromoVino(response[0]);
        } else {
          this.promoSelezionata = {
            risultato: false,
            codice: '',
            valore: 0,
            label: '',
            errore: 'promodialogo.nonvalido',
            data1: '',
            data2: '',
            promo: null,
          };
        }
      });
  }

  controllaPromoVino(promodacontrollare) {
    this.risultato = this.promoService.controllaPromoVino(
      promodacontrollare, this.vino.qta, this.totaleVini, this.totaleVini / this.vino.qta, this.codicePromo
    );
    this.promoSelezionata = this.risultato;
  }

  aggiungiAlCarrello() {
    const valori = {
      idCliente: null,
      idVino: this.vino.id,
      totale: this.totaleVini,
      totalescontato: this.promoSelezionata && this.promoSelezionata.risultato ? this.totalescontato - this.totaleTv : 0,
      qta: this.vino.qta,
      annata: this.formAnnata.value.annata,
      promo: this.promoSelezionata && this.promoSelezionata.risultato ? this.promoSelezionata.codice : ''
    }
    if (this.formAnnata.valid) {
      this.addCarrelloVino(valori);
    } else {
      this.formAnnata.markAllAsTouched();
    }
  }

  addCarrelloVino(valori) {
    this.carrelloService.addCarrello('carrelloVino', valori)
      .subscribe(result => {
        if ((!this.tvSelezionata && !this.tvAssociata) || (!this.tvSelezionata && this.tvAssociata)) {
          this.gestisciRisultatoInserimentoCarrello(result);
        } else {
          if (result['risultato'] === true) {
            const lastID = result['lastID'];
            this.idCookie = result['idCookie'];
            this.addCarrelloBuono(lastID);
          }
        }
      });
  }

  addCarrelloBuono(lastID) {
    const valori = {
      idClientiMaster: this.vino.idcantina,
      idCliente: null,
      idTipoVisita: this.tvSelezionata.id,
      durata: this.tvSelezionata.duratagg,
      tiporegala: this.tvSelezionata.tiporegala,
      fineregala: this.tvSelezionata.fineregala,
      npersone: 1,
      totale: this.getCostoTipovisitaScontato(this.tvSelezionata, this.tvSelezionata.scontoAssociata),
      idCarrelloVini: lastID
    };

    this.carrelloService.addCarrello('carrelloBuonoCantina', valori)
      .subscribe(result => {
        this.gestisciRisultatoInserimentoCarrello(result);
      });
  }

  gestisciRisultatoInserimentoCarrello(result) {
    if (result['risultato'] === true) {
      this.messageService.sendClickMessage(null, null, this.translate.currentLang, 2, this.messageService.getIdCookie());
    }
  }

}
